import React from "react";
import PropTypes from "prop-types";
import { Offcanvas } from "react-bootstrap";
import _Button from "../../../../components/generic/_Button";
import { Form } from "react-bootstrap";
import { useSelectedChannels } from "../hooks/useSelectedChannels";
import { useUpdatePartnerSettings } from "../hooks/useUpdatePartnerSettings";
import { usePreviewChannels } from "../hooks/usePreviewChannels";
const SettingsUserAPI = (props) => {
  const { visible, onClose, title, data = null, refetch = null } = props;
  const { selectedChannels, onToggle, setSelectedChannels } =
    useSelectedChannels();
  const { mutate: updatePartner, isPending } = useUpdatePartnerSettings(
    onClose,
    refetch,
  );

  usePreviewChannels(data, setSelectedChannels);
  return (
    <Offcanvas
      show={visible}
      placement="end"
      backdrop="static"
      onHide={onClose}
      style={{
        width: "400px",
      }}
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{title}</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body className="flex flex-col">
        <div className="flex-1 px-3 py-2">
          <div className="mb-3">
            <h6 className="text-muted">Canales disponibles</h6>
            <small className="text-secondary">
              Selección de canales activos
            </small>
          </div>

          <div className="flex flex-col gap-2">
            {["SMS", "Email", "WhatsApp", "RCS"].map((item) => (
              <div
                key={item}
                className={`p-2 border rounded flex items-center justify-between ${
                  selectedChannels.includes(item)
                    ? "bg-light border-primary"
                    : "bg-white"
                }`}
              >
                <Form.Check
                  type="checkbox"
                  id={item}
                  label={item}
                  checked={selectedChannels.includes(item)}
                  onChange={() => onToggle(item)}
                />

                {selectedChannels.includes(item) && (
                  <span className="badge bg-primary">Activo</span>
                )}
              </div>
            ))}
          </div>
        </div>
        <div className="px-3 py-3 border-t bg-white mt-auto">
          <div className="flex gap-2">
            <_Button
              title="Cerrar"
              style="none"
              className="w-full"
              onClick={onClose}
              loading={isPending}
            />
            <_Button
              title="Guardar"
              style="primary"
              className="w-full"
              onClick={() =>
                updatePartner({
                  data: {
                    channels: selectedChannels,
                    uid_partner: data.uidpartner,
                  },
                })
              }
              loading={isPending}
            />
          </div>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

SettingsUserAPI.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
  data: PropTypes.object,
  refetch: PropTypes.func,
};

export default SettingsUserAPI;
